import { ImResponse, resolve, storeHomeNVClient } from 'services/api';

export function incentiveInfo() {
  return resolve(storeHomeNVClient.get<ImResponse<Incentive.Info>>('/activity/daily_order_count'));
}
